<div class="skeleton-loader m-4">
    <div class="skeleton-row" *ngFor="let row of rows"></div>
  </div>
  